import styled from 'styled-components';
import { Label } from '../../../Components/uielements';
import { palette } from 'styled-theme';
import { css } from '@emotion/react';

export const CounponContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export const ModalLabel = styled(Label)`
  color: ${palette('text', 1)};
  ${(props) =>
    props.isCapitalize &&
    css`
      text-transform: capitalize;
    `}
`;

export const TabContainer = styled.div`
  padding: 20px 20px 12px 20px;
`;

export const TabWrapper = styled.div`
  padding: 0px 20px 12px 20px;
`;

export const CheckBoxContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  gap: 6px;
`;

export const ModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 420px;
`;

export const ModalWrapperInviteVisitor = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 420px;
  max-width: 450px;
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  max-width: fit-content;
  justify-self: center;
`;

export const HeaderTitle = styled(Label)`
  font: normal normal bold 15px Space Grotesk Bold;
`;

export const ContentWrapper = styled.div`
  display: grid;
  gap: 14px;
  height: fit-content;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
